import React from "react";

export const RepeatedBreaks = ({ n }: { n: number }) => {
    return (
        <>
            {Array.from(Array(n).keys()).map((i: number) => (
                <br key={i} />
            ))}
        </>
    );
};
